<template>
    <div class="contain" v-if="contentsId == 0">
        <!-- test -->
        <a href="https://tele.soldoc.co.kr/booking" class="btn lms_ibtn1" target="_blank" @click="gokakao">
            <img src="../assets/btn01.png" alt="Kakao Link"/>
        </a>
        <a href="https://tele.soldoc.co.kr/booking" class="btn lms_ibtn2" target="_blank" @click="gokakao">
            <img src="../assets/btn01.png" alt="Kakao Link"/>
        </a>

        <img class="imgs" src="../assets/220831_LMS.jpg" alt="솔닥, 이렇게 달라졌어요."/>
        <a href="https://tele.soldoc.co.kr/booking" class="btn lms_fbtn" target="_blank" @click="gokakao">
            <img src="../assets/f_btn.png" alt="Kakao 진료실 링크"/>
        </a>
        <popup />
    </div>
    <div v-else>
        <!-- <c1 v-if="contentsId == 1"></c1>
        <c2 v-if="contentsId == 2"></c2> -->
        <c3 v-if="contentsId == 3"></c3>
        <c4 v-if="contentsId == 4"></c4>
        <c5 v-if="contentsId == 5"></c5>
        <c6 v-if="contentsId == 6"></c6>
        <c7 v-if="contentsId == 7"></c7>
        <c8 v-if="contentsId == 8"></c8>
        <c9 v-if="contentsId == 9"></c9>
        <c10 v-if="contentsId == 10"></c10>
        <c11 v-if="contentsId == 11"></c11>
        <c12 v-if="contentsId == 12"></c12>
        <c13 v-if="contentsId == 13"></c13>
        <c14 v-if="contentsId == 14"></c14>
        <c15 v-if="contentsId == 15"></c15>
        <c16 v-if="contentsId == 16"></c16>
        <c17 v-if="contentsId == 17"></c17>
        <c18 v-if="contentsId == 18"></c18>
        <c19 v-if="contentsId == 19"></c19>
        <c20 v-if="contentsId == 20"></c20>
        <c21 v-if="contentsId == 21"></c21>
        <c22 v-if="contentsId == 22"></c22>
        <popup v-if="contentsId !== 3 && contentsId !== 16 && contentsId !== 17 && contentsId !== 18 && contentsId !== 19 && contentsId !== 20 && contentsId !== 21 && contentsId !== 22" :pageButtonClass="currentPageButtonClass" />
    </div>
</template>

<script>

// import c1 from '@/components/pc/contents/c1'
// import c2 from '@/components/pc/contents/c2'
import c3 from '@/components/pc_view/contents/c3'
import c4 from '@/components/pc_view/contents/c4'
import c5 from '@/components/pc_view/contents/c5'
import c6 from '@/components/pc_view/contents/c6'
import c7 from '@/components/pc_view/contents/c7'
import c8 from '@/components/pc_view/contents/c8'
import c9 from '@/components/pc_view/contents/c9'
import c10 from '@/components/pc_view/contents/c10'
import c11 from '@/components/pc_view/contents/c11'
import c12 from '@/components/pc_view/contents/c12'
import c13 from '@/components/pc_view/contents/c13'
import c14 from '@/components/pc_view/contents/c14'
import c15 from '@/components/pc_view/contents/c15'
import c16 from '@/components/pc_view/contents/c16'
import c17 from '@/components/pc_view/contents/c17'
import c18 from '@/components/pc_view/contents/c18'
import c19 from '@/components/pc_view/contents/c19'
import c20 from '@/components/pc_view/contents/c20'
import c21 from '@/components/pc_view/contents/c21'
import c22 from '@/components/pc_view/contents/c22'

import Popup from '@/components/pc_main/Popup';

export default {
    name: 'view',
    data: function()
    {
        return{
            contentsId: 0
        }
    },
    components: {
        // c1,
        // c2,
        c3, 
        c4,
        c5,
        c6,
        c7,
        c8,
        c9,
        c10,
        c11,
        c12,
        c13,
        c14,
        c15,
        c16,
        c17,
        c18,
        c19,
        c20,
        c21,
        c22,
        Popup
    },
    computed: {
        currentPageButtonClass() {
            const { contentsId } = this;
            return `btn-view${contentsId}`;
        },
    },
    mounted: function()
    {
        if(this.$route.query.id)
        {
            this.contentsId = Number(this.$route.query.id); 
        }
        
        //  console.log(this.contentsId)
    },
    methods: {
        gokakao: function(event)
        {
            event.preventDefault(); // 링크의 기본 동작 방지
            window.criteo_q = window.criteo_q || [];
            var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
            window.criteo_q.push(
                { event: "setAccount", account: 96598},

                // To Do 1. 현재 유저의 이메일 주소(공백 제거 및 소문자로 변환 후) 전달. 유저의 이메일을 알수 없는 상황이면 빈 문자열로 전달
                { event: "setEmail", email: "##User Email##" },

                // To Do 2. 현재 유저의 저장된 배송지 우편번호. 유저의 배송지 우편번호를 알수 없는 상황이면 빈 문자열로 전달
                { event: "setZipcode", zipcode: "##Zip Code##" },

                { event: "setSiteType", type: deviceType},

                // To Do 3. 확인 또는 주문 번호를 전달
                // Tip 1. 다른 종류의 전환일 경우 상품 ID에 다른 값으로 전달하여 나중에 리포트를 통해 확인 가능
                { event: "trackTransaction", id: Math.floor(Math.random()*99999999999), item: [
                    {id: "1", price: 1, quantity: 1 }
                ]}
            );

            window.open('https://tele.soldoc.co.kr/booking', '_blank');
        }
    }
}
</script>

<style scoped>
    .contain{
        width: 100%;
        height: 100vh;
        position: relative;
        /* display: flex;
        justify-content: center;
        align-content: center; */
        /* position: relative; */
        /* background: black; */
    }
    .imgs{
       /* width: 100%; */
       /* height: 100%; */
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        }
    .lms_ibtn1{
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        z-index: 10;
        top: 1300px;
        cursor: pointer;
        padding: 0;
    }
    .lms_ibtn2{
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        z-index: 11;
        top: 8550px;
        cursor: pointer;
        padding: 0;
    }
    .lms_fbtn{
        position: fixed;
        bottom: 20px;
        right: 10px;
        width: 80px;
        z-index: 10;
        cursor: pointer;
        padding: 0;
    }
    .lms_fbtn img{
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/page/PcView.vue